;(function () {

"use strict";

var TabsView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.$nav = this.$el.children('ul').first();
    this.$tabs = this.$el.children("ul").last().children();
    this.idx = opts.idx || 0;
    // console.log('INIT TABS');
    // console.log(this);
  },
  changeTab: function (e) {
    var $this = $(e.currentTarget);
    var idx = $this.index();
    if (idx === this.idx) { return; }

    this.idx = idx;
    this.render();
  },
  render: function () {
    this.$tabs.removeClass('active');
    $(this.$tabs[this.idx]).addClass('active');

    this.$nav.find('li').removeClass('active');
    $(this.$nav.find('li')[this.idx]).addClass('active');

    $(window).trigger('resize');
  },
  events: {
    'click ul > li': 'changeTab'
  }
});

module.exports = TabsView;

}());